module.exports = __webpack_public_path__ + "img/2812.3d8cbec2.jpg";